import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import translate from './TranslateHOC';
import CardGridContainer from './CardGridContainer';
import SectionTitle from './SectionTitle';
import { SearchInput as SearchInputV2 } from '../v2/components/header/searchInput/SearchInput';
import { isSignInUp } from '../helpers';

import { updateSearchKeyword, searchResultsRequest } from '../actions';

function FooterSearch({
  history,
  strings,
  getSearchResults,
  updateSearchKeyword,
}) {
  const [searchTerm, setSearchTerm] = useState('');

  const submitSearchRequest = (_searchKeyword) => {
    getSearchResults(_searchKeyword.trim());
  };

  const handleSubmit = () => {
    submitSearchRequest(searchTerm);
    history.push('/search?s=' + searchTerm);
    updateSearchKeyword(searchTerm);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {}, 400);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  return !isSignInUp ? (
    <CardGridContainer type="footer">
      <SectionTitle title={strings.footerSearch} type="footer" />
      <SearchInputV2
        id="clic-search-footer"
        label={strings.footerSearchPlaceholder}
        handleSubmit={handleSubmit}
        handleChange={(e) => setSearchTerm(e.target.value)}
        strings={strings}
      />
    </CardGridContainer>
  ) : null;
}

function mapStateToProps(state) {
  return {
    searchResults: state.searchResults.success,
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    getSearchResults: (keywords) => dispatch(searchResultsRequest(keywords)),
    updateSearchKeyword: (lang) => dispatch(updateSearchKeyword(lang)),
  };
};

export default translate(
  connect(mapStateToProps, mapDispatchToProps)(FooterSearch)
);
